<template>
  <nav class="flex">
    <ol class="breadcrumb">
      <li
        class="breadcrumb-item fsize-22 fw-bold"
        style="text-transform: capitalize"
        :class="Path.length != index + 1 ? 'active' : ''"
        v-for="(data, index) in Path"
        :key="data"
      >
        <template v-if="Path.length != index + 1 && index != 0">
          {{ data.name.replaceAll("-", " ").replace("sla", "SLA") }}
        </template>
        <template v-else>
          {{ data.name.replaceAll("-", " ").replace("sla", "SLA") }}
        </template>
      </li>

      <div class="dropdown" style="flex: auto; text-align: end">
        <button
          class="btn btn-secondary dropdown-toggle sidebar-admin-button bg-white"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fas fa-user-tie icon"></i> &nbsp;Administrator
        </button>
        <ul
          class="dropdown-menu sidebar-admin-menu bg-white"
          aria-labelledby="dropdownMenuButton1"
        >
          <li>
            <a class="dropdown-item sidebar-admin-item" href="#">Profile</a>
          </li>
          <li>
            <a class="dropdown-item sidebar-admin-item" @click="logout" href="#"
              >Log Out</a
            >
          </li>
        </ul>
      </div>
    </ol>
  </nav>
</template>

<script>
import { jwtDecode } from "jwt-decode";
export default {
  computed: {
    Path() {
      const data = this.$route.path.split("/");
      data.shift();
      const payload = [];
      data.forEach((path, index) => {
        let name = path.replaceAll(/[^a-zA-z0-9-]/g, " ")
        if(name == "reports") name = "Add Request Report"
        if(name == "promo-list") name = "UA Promo List"

        let generateLink = "/";
        for (let i = 0; i <= index; i++) {
          generateLink = generateLink + data[i] + "/";
        }
        if (index >= 0) {
          payload.push({
            name,
            link: generateLink,
          });
        }
      });
      return payload;
    },
  },
  methods: {
    async logout() {
      if(process.env.VUE_APP_ENABLE_GOOGLE_LOGIN == 'true') {
        let googleUser
        const storageGsic = localStorage.getItem("gsic")
        
        
        if(storageGsic) {
          googleUser = jwtDecode(storageGsic)
        }
  
        window.google.accounts.id.disableAutoSelect()
        if(googleUser?.sub) {
          window.google.accounts.id.revoke(googleUser.sub, done => {
            console.log(done);
          });
        }
        await this.$store.dispatch("googleLogout", {})
        localStorage.setItem("gsic", "");
      }

      localStorage.setItem("access_token", "");
      this.$router.push("/login");
    },
  },
};
</script>

<style></style>
